const UNICODE_WHITESPACE =
  /[\s\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000\uFEFF]+/g;

export const sanitizeUploadFilename = (filename) => {
  const raw = String(filename || "").trim() || "image";
  const lastDot = raw.lastIndexOf(".");
  const hasExt = lastDot > 0 && lastDot < raw.length - 1;
  const ext = hasExt
    ? raw
        .slice(lastDot + 1)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "")
        .slice(0, 8)
    : "";
  const baseSource = hasExt ? raw.slice(0, lastDot) : raw;
  const base =
    baseSource
      .replace(UNICODE_WHITESPACE, "_")
      .replace(/[^A-Za-z0-9_-]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "") || "image";

  return ext ? `${base}.${ext}` : base;
};

export const webpStoreFilename = (filename) =>
  sanitizeUploadFilename(filename).replace(/\.(png|jpe?g)$/i, ".webp");

export const quotedFilestackStoreFilename = (filename, isGif = false) => {
  const stored = isGif
    ? sanitizeUploadFilename(filename)
    : webpStoreFilename(filename);
  return `"${stored.replace(/"/g, "")}"`;
};

const encodePathSegment = (segment) => {
  try {
    return encodeURIComponent(decodeURIComponent(segment));
  } catch (_e) {
    return encodeURIComponent(segment);
  }
};

export const cdnUrlFromStorageKey = (key) => {
  if (!key) return "";

  const encodedPath = String(key)
    .replace(/^\/+/, "")
    .split("/")
    .map(encodePathSegment)
    .join("/");

  return `https://uploads.convertflow.co/${encodedPath}`;
};
